

export default function BlockPhotos() {

    return (
        <section className="block-photos">
            <div className="photo">
                <img src="/assets/img/home/1.jpg" alt="" />
            </div>
            <div className="photo">
                <img src="/assets/img/home/2.jpg" alt="" />
            </div>
            <div className="photo">
                <img src="/assets/img/home/_DSC9508.jpg" alt="" />
            </div>
        </section>
    )
}